import { FeatureFlags } from './types';
import type { abTest as citationsDashboardAbTest } from 'js/ab_tests/tests/growth_2026_q2_citations_dashboard';

type CitationsDashboardVariant = NonNullable<
  ReturnType<typeof citationsDashboardAbTest>
>;
type NonControlVariant = Exclude<CitationsDashboardVariant, 'control'>;

// Typed against the autogenerated TEST_CONFIG union — TypeScript errors if a listed variant is
// renamed or removed from the YAML config, but NOT if a new non-control variant is added to the
// YAML without being added here. Update this array whenever a new non-control variant is added.
const NON_CONTROL_VARIANTS: ReadonlyArray<NonControlVariant> = [
  'original_landing',
  'blurred_landing',
  'new_landing',
];

export function computeShowCitationsDashboard(
  featureFlags: FeatureFlags | undefined,
  variant: string | null | undefined,
): boolean {
  if (featureFlags?.forceCitationsDashboard) return true;
  const inTest =
    variant != null &&
    (NON_CONTROL_VARIANTS as ReadonlyArray<string>).includes(variant);
  if (!inTest) return false;
  if (featureFlags === undefined) return true;
  return featureFlags.citationsDashboardEnabled;
}
